module.exports = __webpack_public_path__ + "img/mag-abc.02775b10.png";